import { useState } from 'react';

const yearValidate = async (newYear: string) => {
  const numberYear = +newYear;
  if (numberYear < 2050 && numberYear > 1900) {
    return '';
  } else {
    return '< 2050, > 1900';
  }
};

const monthValidate = async (newMonth: string) => {
  const numberMonth = +newMonth;
  if (numberMonth < 13 && numberMonth > 0) {
    return '';
  } else {
    return '< 13, > 0';
  }
};

const dayValidate = async (newDay: string) => {
  const numberDay = +newDay;
  if (numberDay < 32 && numberDay > 0) {
    return '';
  } else {
    return '< 32, > 0';
  }
};

interface DatePickerProps {
  base: Date | undefined;
  isNew: boolean;
}

const useDatePicker = (date: DatePickerProps) => {
  const [year, setYear] = useState(date.base?.getFullYear().toString() ?? '');
  const [isYearValid, setIsYearValid] = useState(!date.isNew);
  const [month, setMonth] = useState(
    date.base ? (date.base?.getMonth() + 1).toString() : ''
  );
  const [isMonthValid, setIsMonthValid] = useState(!date.isNew);
  const [day, setDay] = useState(date.base?.getDate().toString() ?? '');
  const [isDayValid, setIsDayValid] = useState(!date.isNew);
  const setNew = (year = '', month = '', day = '') => {
    setYear(year);
    setMonth(month);
    setDay(day);
    setIsYearValid(false);
    setIsMonthValid(false);
    setIsDayValid(false);
  };

  return {
    setNew,
    yearValidate,
    monthValidate,
    dayValidate,
    year,
    setYear,
    isYearValid,
    setIsYearValid,
    month,
    setMonth,
    isMonthValid,
    setIsMonthValid,
    day,
    setDay,
    isDayValid,
    setIsDayValid,
  };
};

export default useDatePicker;
